import { render } from "./Token.vue?vue&type=template&id=2be5ae35&scoped=true"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"

import "./Token.vue?vue&type=style&index=0&id=2be5ae35&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be5ae35"]])

export default __exports__